<template>
<div class="baselist-container">
  <ToolBar
    :handleToolSide="handleToolSide"
    :handleToolHeadBtn="handleToolHeadBtn"
    :title="title"
    :toolbarIcon="toolbarIcon"
    :toolbarColor="toolbarColor"
    :isLoading="isLoading"
  >
      <v-spacer></v-spacer>
      <ToolbarActions :actions="listActions" />
      <!-- <ViewSelector
        :hasMap="hasMap"
        :hasList="true"
        :hasCard="true"
        :value="listView"
        :selectView="selectView" /> -->
  </ToolBar>

  <v-alert
    :value="showAlert"
    type="error"
    dismissible
    class="my-0"
    @input="hideListAlert">
    {{ errorMessage }}
  </v-alert>

  <glistcontainer
    :key="`${source}`"
    :source="source"
    :list="doc.list"
    :error="error"
    :context="listContext"
    />

    <FullDialog
      :key="`${source}-create`"
      :dialog="createDialog"
      :handleSave="handleCreate"
      :handleClose="handleFormClose"
      :isLoading="isLoading"
      :title="diagTitle"
    >
      <DataForm
        :key="`${source}-create-form`"
        :fields="doc.form.fields"
        :form="form"
        :updateField="updateFormField"
        :hideAlert="hideFormAlert"
        :hasPhoto="doc.form.hasPhoto"
      />
    </FullDialog>

    <Popup
      :key="`${source}-search-dialog`"
      v-if="searchDialog"
      :dialog="searchDialog"
      :hasAdvanced="true"
      :advanced="advancedSearch"
      :toggleAdvanced="() => {advancedSearch = !advancedSearch}"
      :handleSave="handleSearch"
      :handleClose="handleSearchClose"
      :handleReset="handleSearchReset"
    >
      <v-flex xs12 v-if="!advancedSearch">
        <v-text-field
          v-model.trim="quickSearchString"
          label="Trouver..."
          hint="Recherche rapide sur tous les champs"
          clearable
        />
      </v-flex>
      <DataForm
        :key="`${source}-search-dialog-form`"
        v-if="advancedSearch"
        :fields="doc.list.search"
        :form="search"
        :updateField="updateSearchField"
        :inPopup="true"
      />
    </Popup>
</div>
</template>

<script>
import ListContainer from '@/containers/ListContainer'
import FullDialog from '@/components/FullDialog'
import Popup from '@/components/Popup'
import DataForm from '@/components/form/DataForm'
import ToolBar from '@/components/ToolBar'
import ToolbarActions from '@/components/ToolbarActions'
import ViewSelector from '@/components/ViewSelector'
import { filterActions } from '@/utils'

export default {
  components: {
    glistcontainer: ListContainer,
    FullDialog,
    ToolBar,
    DataForm,
    Popup,
    ToolbarActions,
    ViewSelector,
  },
  data: () => ({
    toolbarIcon: 'home',
    advancedSearch: false,
  }),
  computed: {
    dataList () { return this.$store.getters[`${this.source}/list`] },
    hasError () { return this.dataList.hasError },
    errorMessage () { return this.dataList.errors.message },
    showAlert () { return this.dataList.showAlert },
    toolbarColor () { return this.hasError ? 'red darken-3' : 'blue darken-3' },
    isLoading () { return this.$store.getters[`${this.source}/isLoading`] },
    doc () { return this.$store.getters[`${this.source}/doc`] },
    scope () { return this.$store.getters['auth/scope'] },
    form () { return this.$store.getters[`${this.source}/form`] },
    createDialog () { return this.form.dialog },
    search () { return this.$store.getters[`${this.source}/search`] },
    searchDialog () { return this.search.dialog },
    quickSearch () { return this.$store.getters[`${this.source}/quickSearch`] },
    listView () { return this.$store.getters[`${this.source}/listView`] },
    listContext () {
      return {
        params: {
          ...this.doc.params.fetchAll,
        },
        hasList: true,
      }
    },
    listActions () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: {},
      }
      let filtered = filterActions(this.doc.list.actions, {}, this.scope)
      return filtered.map(action => ({
        ...action,
        callBack: () => { this.$store.dispatch(action.dispatch, payload) },
      }))
    },
    title () { return this.error ? this.errorMessage : this.doc.list.name },
    hasMap () { return this.doc.list.hasMap },
    diagTitle () { return `Créer ${this.doc.form.name}` },
    quickSearchString: {
      get () { return this.quickSearch },
      set (value) { this.updateQuickSearch(value) },
    },
  },
  methods: {
    refresh () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: this.search.data,
      }
      this.$store.dispatch(`${this.source}/fetchAll`, payload)
    },
    handleCreate () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: this.form.data,
      }
      this.$store.dispatch(`${this.source}/create`, payload)
    },
    handleFormClose () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: this.form.data,
      }
      this.$store.dispatch(`${this.source}/closeForm`, payload)
    },
    updateFormField (data) {
      let payload = {
        accessors: {},
        context: this.listContext,
        data,
      }
      this.$store.dispatch(`${this.source}/updateFormField`, payload)
    },
    hideFormAlert () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: {},
      }
      this.$store.dispatch(`${this.source}/hideFormAlert`, payload)
    },
    handleSearch () {
      if (this.advancedSearch) {
        this.refresh()
      }
      this.handleSearchClose()
    },
    handleSearchClose () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: {},
      }
      this.$store.dispatch(`${this.source}/closeSearch`, payload)
    },
    updateQuickSearch (value) {
      this.$store.dispatch(`${this.source}/smartSearch`, value)
    },
    handleSearchReset () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: {},
      }
      this.$store.dispatch(`${this.source}/smartSearch`, '')
      this.$store.dispatch(`${this.source}/resetSearch`, payload)
        .then(() => {
          this.refresh()
        })
    },
    updateSearchField (data) {
      let payload = {
        accessors: {},
        context: this.listContext,
        data,
      }
      this.$store.dispatch(`${this.source}/updateSearchField`, payload)
    },
    selectView (data) {
      let payload = {
        accessors: {},
        context: this.listContext,
        data,
      }
      this.$store.dispatch(`${this.source}/setListView`, payload)
    },
    handleToolSide () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: {},
      }
      this.$store.dispatch('ui/toggleDrawer', payload)
    },
    handleToolHeadBtn () {
      this.$router.push({path: '/'})
    },
    hideListAlert () {
      let payload = {
        accessors: {},
        context: this.listContext,
        data: {},
      }
      this.$store.dispatch(`${this.source}/hideListAlert`, payload)
    },
  },
  props: {
    source: String,
    error: Boolean,
  },
  beforeRouteUpdate (to, from, next) {
    // react to route changes...
    console.log(this.source, this.label)
    // don't forget to call next()
    next()
  },
  created () {
    console.log(`BaseList: ${this.source} created`)
  },
  destroyed () {
    console.log(`BaseList: ${this.source} destroyed`)
  },
}
</script>

<style scoped>
  .baselist-container {
    position: relative;
    height: 100%;
    width: 100%;
  }
</style>
